import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { OrganisationBase } from '../models/organisation-base';
import { OrganisationTree } from '../models/organisation-tree';
import { OrganisationOption } from '../models/forms/user-form';
import { OrganisationSelectorComponent } from '../organisation-selector/organisation-selector.component';

@Component({
    selector: 'app-multiple-organisation-selector',
    templateUrl: './multiple-organisation-selector.component.html',
    styleUrls: ['./multiple-organisation-selector.component.sass'],
    standalone: false
})
export class MultipleOrganisationSelectorComponent implements AfterViewInit {

  @Input() organisationsForm!: FormControl<OrganisationOption[]>;
  @Input() organisationTree!: OrganisationTree;

  @ViewChild('orgSelector', { static: true }) orgSelector!: OrganisationSelectorComponent;

  ngAfterViewInit() {
    this.orgSelector.computeOrganisations(this.organisationsForm.value.map(o => o.organisationRef));
    this.organisationsForm.valueChanges.subscribe(newValue => {
      this.orgSelector.computeOrganisations(newValue.map(o => o.organisationRef));
    })
  }

  addOrganisation(organisation: OrganisationBase | null) {
    if (!organisation)
      return;

    let currentValue = [...this.organisationsForm.value];
    currentValue.push({
      organisationRef: organisation.organisationRef,
      name: organisation.name
    })
    this.organisationsForm.setValue(currentValue);
  }

  removeOrganisation(idx: number) {
    let selectedOrganisations = [...this.organisationsForm.value];
    selectedOrganisations.splice(idx, 1);
    this.organisationsForm.setValue(selectedOrganisations);
  }
}
